
export { ISoftEvents } from "./lib/softManager/interfaces"